// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';
import BgImg from '../assets/images/G42-Background.svg';

const colors = {
  bgLight: '#f0faf3',
  border: '#00403E33',
  white: '#fff',
  white80: '#FFFFFF80',
  darkGreen: '#004140',
  darkGreen80: '#004140B2'
} as const;

// LoginForm

export const loginFormContainer: CSSProperties = {
  backgroundImage: `url(${BgImg})`,
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  height: '100vh',
  width: '100%'
};

export const loginFormSection: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',
  height: '100vh'
};

export const submitForm: CSSProperties = {
  position: 'absolute',
  width: '400px',
  maxWidth: '600px',
  right: '10%',
  padding: '30px',
  background: colors.white,
  border: '0.5px solid #00403E33',
  borderRadius: '12px'
};

export const signInHeading: CSSProperties = {
  fontSize: '32px',
  fontWeight: 600,
  color: colors.darkGreen
};

export const userLoginBtn: CSSProperties = {
  padding: '16px 20px',
  marginTop: 40,
  fontSize: 16,
  fontWeight: 600,
  backgroundColor: colors.darkGreen,
  color: colors.white,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '6px'
};
